import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import dashboard from './modules/dashboard'
import context from './modules/context'
import task from './modules/task'
import coding from './modules/coding'
import vismem from './modules/vismem'
import vm from './modules/vm'
import survey from './modules/survey'
// import * as actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
    // plugins: [createPersistedState()],
    state: {
        user: {
            consent_given_at: null,
            userId: null,
            wants_result_summary: null,
            result_summary: null,
            urt: null,
        },
        project: {
            id: null,
            project_ref: null,
            consent_text: null,
            link_login: null,
            pdf: false
        }
    },
    modules: {
        dashboard,
        context,
        task,
        coding,
        vismem,
        vm,
        survey
    },
    actions: {
        setProject: ({commit}, payload) => {
            commit('SET_PROJECT', payload)
        },
        setUser: ({ commit }, payload) => {
            commit('SET_USER', payload)
        },
        setUserUrt: ({ commit }) => {
            commit('SET_USER_URT')
        },
        clearState: ({ commit }, payload) => {
            commit('CLEAR_STATE')
        },
    },
    getters: {
        getUserId: (state) => {
            return state.user.userId
        },
        getProject: (state) => {
            return state.project
        },
        getResultSummary: (state) => {
            return state.user.result_summary
        },
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user
        },
        SET_PROJECT(state, project) {
            state.project = project
        },
        SET_USER_URT(state) {
            state.user.urt = true
        },
        CLEAR_STATE(state) {
            state.user = {
                consent_given_at: null,
                userId: null,
                wants_result_summary: null,
                result_summary: null,
                urt: null,
            }
            state.dashboard = {
                currentComponent: 'consent',
            }
            state.context = {
                contextState: {
                    consent: {
                        component: 'Consent',
                        consentStatus: false,
                        consentTimestamp: '',
                        completed: false,
                    },
                    audiocheck: {
                        component: 'AudioCheck',
                        completed: false,
                    },
                    questions: {
                        component: 'Rules',
                        answers: '',
                        completed: false,
                    },
                    task: {
                        component: 'Task',
                        completed: false,
                    },
                    done: {
                        component: 'Done',
                        responses: '',
                        completed: false,
                    },
                    feedback: {
                        component: 'Feedback',
                        feedback: '',
                        completed: false,
                    },
                    resultsummary: {
                        component: 'Resultsummary',
                        feedback: '',
                        completed: false,
                    },
                    logout: {
                        component: 'Logout',
                        completed: false,
                    },
                    currentContext: 'consent',
                },
            }
            state.task = {
                taskStates: [],
                currentTaskIndex: '',
                currentTask: '',
                currentTaskComponent: '',
                currentResultId: null,
                userAbortStatus: false,
            }
            state.coding = {
                codingKey: '',
            }
            state.vismem = {
                initialPositions: '',
            }
            state.vm = {
                wordList: '',
            }
        },
    },
})



// WEBPACK FOOTER //
// ./src/store/store.js